import { render } from "./editcategory.vue?vue&type=template&id=d2b60426"
import script from "./editcategory.vue?vue&type=script&lang=js"
export * from "./editcategory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__